<template>
  <div class="search-place">
    <input type="text" v-model="search" placeholder="Code postal ou ville" @input="searchPlaces">
    <div class="dropdown" v-if="places.length">
      <perfect-scrollbar :options="scrollbarOptions">
        <div class="inner">
          <div class="result" v-for="(place, index) in places" :key="index" @click.prevent="selectPlace(place)">{{ place.place_name }}</div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import SmallLoader from './SmallLoader'

import { debounce } from 'lodash'
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SearchPlace',
  data () {
    return {
      search: null,
      scrollbarOptions: {
        wheelPropagation: false,
        suppressScrollX: true
      }
    }
  },
  computed: {
    ...mapState({
      places: state => state.places.items,
      loading: state => state.places.loading
    })
  },
  methods: {
    ...mapActions('places', ['getPlaces', 'clearPlaces']),
    searchPlaces: debounce(function (e) {
      this.getPlaces(e.target.value)
    }, 700),
    selectPlace(place) {
      this.$emit('selected', place.center)
      this.search = null
      this.clearPlaces()
    }
  },
  components: {
    SmallLoader,
    PerfectScrollbar
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.search-place{
  position: relative;

  input{
    height: 40px;
    padding: 0 20px;
    font-family: $poppins;
    font-size: px2rem(14px);
    color: $black;
    outline: none;
    border: none;
    @include radius(20px);
    @include box-sizing();
  }

  .dropdown{
    position: absolute;
    top: 100%;
    left: 0;
    max-height: 200px;
    background-color: lighten($primary, 5%);
    z-index: 1000;
    border-top: none;
    overflow: hidden;
    @include radius(10px);
    @include transform(translateY(5px));

    .result{
      color: $white;
      padding: 10px 10px;
      font-size: px2rem(14px);
      line-height: 20px;
      border-bottom: 1px solid lighten($primary, 10%);
      cursor: pointer;

      &:hover{
        background-color: lighten($primary, 15%);
      }

      &:last-child{
        border-bottom: none;
      }
    }
  }
}
</style>


<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.search-place{
  .dropdown{
    .ps{
      height: 200px;

      .ps__rail-y{
        width: 6px;
        opacity: 0.7;
        margin: 0;

        &:hover, &.ps--clicking{
          background: none;
          opacity: 1;

          .ps__thumb-y{
            width: 6px;
          }
        }

        .ps__thumb-y{
          background-color: rgba(black, 0.5);
          right: 0;
        }
      }
    }
  }
}
</style>

